import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const buttonVariants = {
    hover: {
      scale: 1.1,
      textShadow: '0px 0px 8px rgb(255, 255, 255)',
      boxShadow: '0px 0px 8px rgb(255, 255, 255)',
      transition: {
        duration: 0.3,
        yoyo: Infinity,
      },
    },
  };

  return (
    <motion.div
      className="fixed top-0 w-full bg-white z-50 shadow-md"
      initial={{ y: -250 }}
      animate={{ y: 0 }}
      transition={{ delay: 0.2, type: 'spring', stiffness: 120 }}
    >
      <div className="flex justify-between items-center p-4">
        <div className="flex items-left">
          {/* TranXEnergy */}
          <img
          src= "/ESG_Logo.png"
          alt= "Logo"
          className= "w-[110px] h-[45px]">
          </img>
        </div>
        <div className="hidden space-x-8 md:flex font-semibold">
        {/*Solutions, Certifications, Company (Newsletter, about us), Career, FAQ, Log In*/}
          <NavLink
            to="#solutions" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300"
          >
            Solutions
          </NavLink>
          <NavLink
            to="#certifications" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300"
          >
            Certifications
          </NavLink>
          <NavLink
            to="#aboutus" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300"
          >
            About
          </NavLink>
          <NavLink
            to="#career" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300"
          >
            Career
          </NavLink>
          <NavLink
            to="#faq" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300"
          >
            FAQ
          </NavLink>
          <motion.div variants={buttonVariants} whileHover="hover">
            <NavLink
              to="/sign-in"
              className="bg-[#80C32DB2] text-[#000000] px-6 py-3 rounded-full font-semibold shadow-lg transition-all transform hover:-translate-y-1"
            >
              Log In
            </NavLink>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Navbar;
